module.exports = __webpack_public_path__ + "assets/images/04_active_47bb399cc497acaccac98229fc4a0418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04_active.png
// module id = 169
// module chunks = 0